import { resolveMediaIdentityTitle } from "@/components/OmniCine/media/resolveMediaTitle";
import { resolveDockContext } from "@/components/OmniCine/Docks/shared/mediaDock.helpers";
import type { AudioDockIdentity, AudioDockSelectorInput } from "@/components/OmniCine/Docks/audio/audioDock.types";

function pickAudioMemberLabel(args: Pick<AudioDockIdentity, "binding" | "family" | "members">): string | null {
  const preferredMemberId = args.binding?.audioMemberId ?? args.family?.preferredAudioMemberId;
  const member = preferredMemberId ? args.members.find((entry) => entry.id === preferredMemberId) : null;
  return member?.label ?? null;
}

function pickAudioPreviewUrl(
  input: AudioDockSelectorInput,
  resolved: Pick<AudioDockIdentity, "binding" | "family" | "members" | "metadata" | "focusedClipMediaUrl">,
): string | null {
  const preferredMemberId = resolved.binding?.audioMemberId ?? resolved.family?.preferredAudioMemberId;
  const member = preferredMemberId ? resolved.members.find((entry) => entry.id === preferredMemberId) : null;
  return (
    input.externalPreview?.url ??
    input.focusMedia?.mediaUrl ??
    input.focusIntent?.mediaUrl ??
    member?.mediaUrl ??
    resolved.metadata?.waveformProxyUrl ??
    resolved.metadata?.mediaUrl ??
    resolved.focusedClipMediaUrl ??
    null
  );
}

export function selectAudioDockIdentity(input: AudioDockSelectorInput): AudioDockIdentity {
  const resolved = resolveDockContext(input);
  const previewLabel =
    input.focusMedia?.label ??
    input.focusIntent?.clipLabel ??
    input.focusIntent?.label ??
    resolved.metadata?.sourceLabel ??
    resolved.focusedClipLabel ??
    pickAudioMemberLabel(resolved) ??
    input.externalPreview?.label ??
    input.selectedAsset?.label ??
    "Media Preview";
  const resolvedPreviewUrl = pickAudioPreviewUrl(input, resolved);

  return {
    ...resolved,
    previewLabel,
    resolvedPreviewUrl,
    title: resolveMediaIdentityTitle({
      clipTitle: input.focusMedia?.label ?? input.focusIntent?.clipLabel ?? input.focusIntent?.label ?? resolved.focusedClipLabel,
      assetDisplayName: input.selectedAsset?.label ?? resolved.focusedClipLabel,
      importedLabel: previewLabel,
      mediaUrl: resolvedPreviewUrl,
      mediaId: input.focusMedia?.mediaId ?? resolved.focusedClipMediaId ?? input.selectedAsset?.id,
      kind: "audio",
    }),
    subtitle: "Audio Focus",
    kindChip: "AUDIO",
    sourceChip: resolved.sourceChip,
  };
}